import { render } from "./VideosCarousel.vue?vue&type=template&id=01bf5fb2&scoped=true&ts=true"
import script from "./VideosCarousel.vue?vue&type=script&lang=ts"
export * from "./VideosCarousel.vue?vue&type=script&lang=ts"

import "./VideosCarousel.vue?vue&type=style&index=0&id=01bf5fb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bf5fb2"]])

export default __exports__